import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetUncovered extends AbstractProductType {

  name = 'valet_uncovered'
  title = 'Valet Uncovered'

  valet = true

  format = ProductTypeFormat.Uncovered

}
